export class NestedError extends Error {
	constructor(message: string, error: Error) {
		const mess = `${message}: ${error.toString()}`
		super(mess)
	}
}
